import axios from "axios";
import { getApiBaseUrl, calSign, isDevEnv, isTestEnv } from "@/utils/tools";
import ALL_URL, { MOCK_CONFIG } from "@/api/url";

const instance = axios.create({
    baseURL: getApiBaseUrl(),
    headers: {
        "Content-Type": "application/json"
    },
    timeout: 60000
});

instance.interceptors.request.use(config => {
    config.data = { source: 2, ...config.data };

    const accessToken = localStorage.getItem('accessToken') || null;
    config.headers['Authorization'] = calSign(config.url, config.data, accessToken);

    if (isDevEnv() || isTestEnv()) {
        const env = isDevEnv() ? '开发' : '测试';
        console.log(`[${env}环境] 请求:`, { url: config.url, data: config.data });
    }

    return config;
});

instance.interceptors.response.use(
    res => res.config.responseType === 'blob' ? res : res.data,
    error => Promise.reject(error)
);

async function request(config) {
    // 下载文件模式
    const isDownload = config.isDownload;
    if (isDownload) {
        config.responseType = 'blob';
        delete config.isDownload;
    }

    if (import.meta.env.DEV) {
        const entry = Object.entries(ALL_URL).find(([, path]) => path === config.url);
        if (entry) {
            const [key] = entry;
            if (MOCK_CONFIG[key]) {
                const { default: mockData } = await import("@/api/mock");
                const mockResp = mockData[key];
                if (mockResp) {
                    console.log(`[Mock] ${config.method?.toUpperCase()} ${config.url}`, mockResp);
                    return mockResp;
                }
            }
        }
    }

    const res = await instance(config);
    // 下载模式返回完整 response（含 blob 和 headers）
    return isDownload ? res : res;
}

export default request;
